/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Message,
} from '../models/index';
import {
    MessageFromJSON,
    MessageToJSON,
} from '../models/index';

export interface GetPartnerMessagesRequest {
    partnerId: number;
}

/**
 * 
 */
export class MessagesApi extends runtime.BaseAPI {

    /**
     * Get messages for a partner
     */
    async getPartnerMessagesRaw(requestParameters: GetPartnerMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Message>>> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling getPartnerMessages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/messages/partner/{partnerId}`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MessageFromJSON));
    }

    /**
     * Get messages for a partner
     */
    async getPartnerMessages(requestParameters: GetPartnerMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Message>> {
        const response = await this.getPartnerMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
